import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingPaymentMarkAsPaid {
  paymentId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingPaymentMarkAsPaid = ({ paymentId, onSuccess, onError }: UseBillingPaymentMarkAsPaid) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingPaymentMarkAsPaid', paymentId],
    mutationFn: () => privateAxios.put(`/billing/payments/${paymentId}/mark_as_paid`),
    onSuccess,
    onError,
  });
};
